<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Document</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            placeholder="Please Select"
            v-model="form.type"
            label="Document Type"
            :options="types"
            :required="true"
            :show-error="form.errors.has('type')"
            helper="Please select a document type to upload"
            :error-message="form.errors.get('type')"
            key-name="identifier"
          ></selectlist>
          <file-input
            name="document"
            label="Document"
            :required="true"
            helper="Please choose a file"
            :show-error="form.errors.has('document')"
            v-on:selected="setDocument"
            :error-message="form.errors.get('document')"
          ></file-input>
          <input-block
            name="description"
            label="Description"
            v-model="form.description"
            helper="Please enter a description for the document you are adding"
          ></input-block>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="addDocument"
        >Add Document</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    rejected: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    types: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      form: new window.Form({
        document: null,
        type: null,
        description: null
      })
    };
  },

  methods: {
    closeModal() {
      this.form.reset();
      this.$emit('close');
    },

    setDocument(data) {
      this.form.addFile(data.name, data.file);
    },

    addDocument() {
      this.form
        .post(
          `/incidents/${this.incident}/documents${
            this.rejected ? '?filter[status]=rejected' : ''
          }`
        )
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Oops, there was an error uploading the documents'
          );
        });
    }
  }
};
</script>
